export const ORDER_LAB_STATUS = {
  dispatching: [1, 2, 3, 4],
  posted: [5],
  atTheLab: [6],
  partnerReview: [11],
  beingReviewed: [7, 12],
  onHold: [14],
  hold: [17],
  completed: [8],
  cancelled: [9],
  appointmentBookingRequired: [19],
};
